/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  class AnchorLinks extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      document.querySelectorAll(".anchor-link").forEach(function (link) {
        link.addEventListener("click", function () {
          let number = this.dataset.number;
          let target = document.querySelectorAll(
            "#MainContent .shopify-section"
          )[number - 1];
          if (target) {
            const yOffset = -100;
            const y =
              target.getBoundingClientRect().top + window.scrollY + yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
          }
        });
      });
    }
  }
  customElements.define("anchor-links", AnchorLinks);

  class Contact extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      document.getElementById("reason").addEventListener("change", function () {
        var selectedOption = this.options[this.selectedIndex];
        var dataHandle = selectedOption.getAttribute("data-handle");

        document
          .querySelectorAll(".powr-form-builder")
          .forEach((form) => form.classList.remove("active"));
        document
          .querySelector(`.powr-form-builder[data-handle="${dataHandle}"]`)
          .classList.add("active");
      });

      if (window.location.href.includes("?wholesale")) {
        document
          .querySelectorAll(".powr-form-builder")
          .forEach((form) => form.classList.remove("active"));
        document
          .querySelector(`.powr-form-builder[data-handle="wholesale"]`)
          .classList.add("active");

        var selectElement = document.getElementById("reason");
        for (var i = 0; i < selectElement.options.length; i++) {
          if (
            selectElement.options[i].getAttribute("data-handle") === "wholesale"
          ) {
            selectElement.selectedIndex = i;
            var event = new Event("change");
            selectElement.dispatchEvent(event);
            break;
          }
        }
      }
    }
  }
  customElements.define("contact-page", Contact);

  // wholesale popup
  document.querySelectorAll(".wholesale-popup-close").forEach(function (btn) {
    btn.addEventListener("click", function () {
      document
        .querySelector(".wholesale-popup-inner")
        .classList.remove("active");
      setTimeout(() => {
        document.querySelector(".wholesale-popup").classList.remove("active");
      }, 300);
    });
  });

  document.querySelectorAll(".wholesale-trigger").forEach(function (btn) {
    btn.addEventListener("click", function () {
      document.querySelector(".wholesale-popup").classList.add("active");
      setTimeout(() => {
        document
          .querySelector(".wholesale-popup-inner")
          .classList.add("active");
      }, 100);
    });
  });

  function updateVariantPackaging(form, variantInput) {
    if (!form || !variantInput) return;

    var is100Count =
      variantInput.dataset.isOneHundredCount === "true";

    form.querySelectorAll("[data-variant-size-text]").forEach(function (label) {
      var text = is100Count
        ? label.dataset.oneHundredCountText
        : label.dataset.defaultText;

      label.textContent = text ? "(" + text + ")" : "";
      label.hidden = !text;
    });

    form
      .querySelectorAll("[data-100-count-disclaimer]")
      .forEach(function (disclaimer) {
        disclaimer.hidden = !is100Count;
      });
  }

  function initializeVariantPackaging(root) {
    root.querySelectorAll("form[data-product-form]").forEach(function (form) {
      var selectedVariantId = form.querySelector(
        "input[name='id'][data-product-select]"
      );
      var variantInput = selectedVariantId
        ? form.querySelector(
            ".variant-option[data-variant-id='" +
              selectedVariantId.value +
              "']"
          )
        : null;

      if (!variantInput) {
        variantInput = form.querySelector(".variant-option:checked");
      }

      updateVariantPackaging(form, variantInput);
    });
  }

  document.addEventListener("change", function (event) {
    if (!event.target.matches("input.variant-option")) return;
    updateVariantPackaging(
      event.target.closest("form[data-product-form]"),
      event.target
    );
  });

  document.addEventListener("theme:variant:change", function (event) {
    var productRoot = event.target.closest("[data-product]") || event.target;
    var form = productRoot.matches("form[data-product-form]")
      ? productRoot
      : productRoot.querySelector("form[data-product-form]");
    var variant = event.detail && event.detail.variant;
    if (!form || !variant) return;

    updateVariantPackaging(
      form,
      form.querySelector(
        ".variant-option[data-variant-id='" + variant.id + "']"
      )
    );
  });

  document.addEventListener("shopify:section:load", function (event) {
    initializeVariantPackaging(event.target);
  });

  initializeVariantPackaging(document);

  let currentIndex = 0;
})();
